import React from 'react';

export default function SettingsCreateButton({ label, onClick }) {
	return (
		<button type="button" className="ats-button-primary" onClick={onClick}>
			{label}
		</button>
	);
}
